import type { Airflow } from '@aviata/platform-types';

import { api } from '@/shared/api';
import { sentryModel } from '@/shared/model';

export const getOfferDetails = async ({
  resultId,
  offerId,
  fareFamilyId,
}: {
  resultId: string;
  offerId: string;
  fareFamilyId?: string;
}) => {
  try {
    const options = fareFamilyId ? { fareFamilyId } : undefined;
    const { data } = await api.airflow.details(resultId, offerId, options);
    return data as unknown as Airflow.Offer.Details;
  } catch (cause) {
    const error = sentryModel.getReadableError(
      'ERR_COULD_NOT_FETCH_DETAILS',
      cause as Error,
    );
    sentryModel.captureException(error);

    throw error;
  }
};
